"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddNewBar = void 0;
const core_1 = require("@material-ui/core");
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const PlusIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PlusIcon"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    container: {
        padding: 7,
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        borderTop: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
    },
    root: {
        backgroundColor: lib_palette_1.default.White.main,
    },
    inputRoot: {
        paddingRight: 4,
    },
});
function AddNewBar(props) {
    const { addLabel, onAddNew } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const [title, setTitle] = (0, react_1.useState)('');
    const [adding, setAdding] = (0, react_1.useState)(false);
    const handleAddNew = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (!onAddNew)
            return;
        setAdding(true);
        yield onAddNew(title);
        setAdding(false);
        setTitle('');
    }), [onAddNew, title]);
    const handleKeyDown = (0, react_1.useCallback)(e => {
        if (e.keyCode === KeyCodes_1.default.ENTER) {
            handleAddNew().catch(doNothing_1.default);
            e.preventDefault();
        }
        e.stopPropagation();
    }, [handleAddNew]);
    return (react_1.default.createElement("div", { className: myCss.container },
        react_1.default.createElement(TextField_1.default, { noMargin: true, fullWidth: true, placeholder: addLabel, value: title, onChange: setTitle, onKeyDown: handleKeyDown, className: myCss.root, InputProps: {
                classes: { root: myCss.inputRoot },
                endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                    react_1.default.createElement(Button_1.default, { small: true, bordered: false, disabled: !title || adding, loading: adding, onClick: handleAddNew, icon: react_1.default.createElement(PlusIcon_1.default, { size: 14 }) }))),
            } })));
}
exports.AddNewBar = AddNewBar;
exports.default = AddNewBar;
